/**
 * Names on the rates screens. Reads the active language from the i18next
 * singleton, like core's formatters, so a component using it needs
 * `useTranslation()` to re-render when the language changes.
 */
import type { RateSourceDto } from '@forsys/shared';
import { MANUAL_RATE_SOURCE } from '@forsys/shared';
import { currentLanguage } from '../../i18n';

/** "Czech koruna", or an empty string where the browser has no name for the code. */
export function currencyName(code: string): string {
  try {
    const name = new Intl.DisplayNames([currentLanguage()], { type: 'currency' }).of(code);
    return name && name !== code ? name : '';
  } catch {
    return '';
  }
}

/** A source's name; `manual` as the caller's word for it; an unknown key as itself. */
export function sourceLabel(key: string, sources: readonly RateSourceDto[], manual: string): string {
  if (key === MANUAL_RATE_SOURCE) return manual;
  return sources.find((source) => source.key === key)?.label ?? key;
}
